import React, { Children } from 'react'
import { Container } from './styled'

interface Props {
  children: JSX.Element | JSX.Element[]
  autoArrangeWidth?: boolean
}

export const Wrapper = ({ children, autoArrangeWidth = true }: Props) => {
  let buttonsQty = 0

  Children.forEach(children, (child) => {
    if (child && child.type.displayName === 'Button') {
      buttonsQty++
    }
  })

  return (
    <Container
      buttonsQty={buttonsQty}
      autoArrangeWidth={autoArrangeWidth}
    >
      {children}
    </Container>
  )
}

export const Styled = Container
